import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');


$('.accordion').each(function () {

    if (inBackend) return;

    const $accordion = $(this);
    const $accordionHeader = $accordion.find('.accordion-header');
    const $accordionContent = $accordion.find('.accordion-content');

    // Initially close
    if (!$accordion.hasClass('accordion-init-open')) {
        $accordionContent.hide();
        $accordion.addClass('closed');
    }

    // Open/close when header is clicked
    $accordionHeader.on('click', function (event) {
        event.preventDefault();
        if ($accordion.hasClass('closed')) {
            open();
        } else {
            close();
        }
    });

    function close() {
        $accordionContent.slideUp(250);
        $accordion.addClass('closed');
    }

    function open() {
        $accordionContent.slideDown(250);
        $accordion.removeClass('closed');
    }


});
